export default function isSubset<T>(array1: T[], array2: T[]) {
  return array1.every((item1) => array2.includes(item1))
}
